import { useCallback } from "react";

const useSupportChat = () => {
    const openSupportChat = useCallback(() => {
        if (typeof window !== "undefined" && typeof window.Intercom === "function") {
            try {
                window.Intercom("show");
            } catch (err) {
                console.error("Fin chat open failed:", err);
            }
        }
    }, []);

    return { openSupportChat };
};

export default useSupportChat;
